// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Ao-z","slideIn":"Bo-z"};